<template>
  <div class="game-login-container">
    <el-card class="box-card" shadow="hover">
      <!-- 顶部操作区：下载链接与标题 -->
      <div class="header-section">
        <h2 class="page-title">微信游戏一键登录管理</h2>
        <a
            type="primary"
            icon="el-icon-download"
            size="small"
            href="https://darknight-1300577131.cos.ap-nanjing.myqcloud.com/onekeyloginVV3.zip"
            target="_blank"
        >
          下载登录插件
        </a>
      </div>

      <!-- 步骤条 -->
      <div class="steps-section">
        <el-steps :active="4" align-center finish-status="success">
          <el-step title="步骤 1" description="下载插件"></el-step>
          <el-step title="步骤 2" description="Chrome 添加扩展"></el-step>
          <el-step title="步骤 3" description="右键选择一键助手"></el-step>
          <el-step title="步骤 4" description="失效可上传 Cookie"></el-step>
        </el-steps>
      </div>

      <!-- 表格工具栏：筛选与统计 -->
      <div class="table-toolbar">
        <div class="filter-group">
          <span class="label-text">设备筛选：</span>
          <el-select
              v-model="phoneType"
              placeholder="请选择设备"
              size="small"
              style="width: 200px;"
              @change="search(1)"
          >
            <el-option label="手机0(yejiaoliuwei1)" :value="0"></el-option>
            <el-option label="手机 1" :value="1"></el-option>
            <el-option label="手机 3" :value="3"></el-option>
            <el-option label="手机 4" :value="4"></el-option>
          </el-select>

          <el-button type="primary" size="small" @click="search(1)">搜索</el-button>

          <el-button type="success" size="small" icon="el-icon-plus" @click="openAddDialog">新增游戏</el-button>

        </div>

        <div class="stat-group" >

          <el-input
              v-model="searchKeyword"
              placeholder="输入游戏名称搜索->按回车确认"
              size="small"      style="width: 260px; margin-right: 10px;"
              clearable
              @keyup.enter.native="searchByName"
          ></el-input>
          <el-tag size="small" effect="plain">共 {{ tableData.length }} 个游戏</el-tag>
        </div>
      </div>

      <!-- 数据表格 -->
      <div class="table-wrapper">
        <el-table
            :data="tableData"
            border
            stripe
            size="mini"
            highlight-current-row
            style="width: 100%"
            v-loading="loading"
            @row-click="click"
            @row-contextmenu="click"
        >
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>

          <el-table-column prop="gameName" label="游戏名称" align="center" min-width="180">
            <template slot-scope="scope">
              <i class="el-icon-game-controllers" style="color: #409EFF; margin-right: 5px;"></i>
              {{ scope.row.gameName }}
            </template>
          </el-table-column>

          <el-table-column prop="phoneNumber" label="手机编号" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.phoneNumber == null ? '-' : scope.row.phoneNumber }}
            </template>
          </el-table-column>

          <el-table-column prop="gameName" label="账号" align="center" min-width="180">
            <template slot-scope="scope">
              <i class="el-icon-game-controllers" style="color: #409EFF; margin-right: 5px;"></i>
              {{ scope.row.gameZh }}
            </template>
          </el-table-column>

          <el-table-column prop="gameName" label="密码" align="center" min-width="180">
            <template slot-scope="scope">
              <i class="el-icon-game-controllers" style="color: #409EFF; margin-right: 5px;"></i>
              {{ scope.row.gamePsw }}
            </template>
          </el-table-column>

          <el-table-column prop="loginStatus" label="登录状态" align="center" min-width="180">
            <template slot-scope="scope">
              <!-- 根据 loginStatus 值动态设置标签类型 -->
              <el-tag
                  :type="scope.row.loginStatus == 1 ? 'success' : 'danger'"
                  effect="dark"
                  size="small"
              >
                {{ scope.row.loginStatus == 1 ? '登录正常' : '登录失效' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="状态" width="150" align="center">
            <template slot-scope="scope">
              <el-tag
                  :type="scope.row.state === 0 ? 'success' : 'info'"
                  effect="dark"
                  size="small"
              >
                {{ formatter(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 在 el-table 中添加操作列 -->
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click.stop="openEditDialog(scope.row)"
              >
                编辑账号
              </el-button>
            </template>
          </el-table-column>


          <!--          <el-table-column label="操作" width="120" align="center">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button type="text" size="small" @click.stop="click(scope.row)">-->
          <!--                {{ scope.row.state === 0 ? '刷新状态' : '尝试登录' }}-->
          <!--              </el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
        <el-pagination
            style="text-align: center; margin-top: 10px;"
            background
            layout="prev, pager, next,total"
            :page-size="15"
            :total="total"
            :current-page="currentPage"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 新增：编辑账号密码的对话框 -->
    <el-dialog title="编辑账号密码" :visible.sync="editDialogVisible" width="30%">
      <el-form :model="editForm" label-width="80px">
        <el-form-item label="游戏名称">
          <el-input v-model="editForm.gameName" disabled></el-input>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="editForm.gameZh" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="editForm.gamePsw" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="手机编号">
          <el-input v-model.number="editForm.phoneNumber" type="number" placeholder="输入授权手机编号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="editDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitUpdate" :loading="submitLoading">确 定</el-button>
  </span>
    </el-dialog>

    <!-- 新增：添加游戏的对话框 -->
    <el-dialog title="添加新游戏" :visible.sync="addDialogVisible" width="35%">
      <el-form :model="addForm" :rules="addRules" ref="addFormRef" label-width="100px">
        <el-form-item label="游戏名称" prop="gameName">
          <el-input v-model="addForm.gameName" placeholder="请输入游戏名称"></el-input>
        </el-form-item>
        <el-form-item label="游戏账号" prop="gameZh">
          <el-input v-model="addForm.gameZh" placeholder="请输入游戏账号"></el-input>
        </el-form-item>
        <el-form-item label="游戏密码" prop="gamePsw">
          <el-input v-model="addForm.gamePsw" type="password" placeholder="请输入游戏密码"></el-input>
        </el-form-item>
        <el-form-item label="手机编号" prop="phoneNumber">
          <el-input v-model.number="addForm.phoneNumber" type="number" placeholder="输入授权手机编号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd" :loading="addLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GameLogin",
  data() {
    return {
      phoneType: 0,
      tableData: [],
      loading: false,
      // 保留原有路由参数逻辑
      value: '',
      count: 0,
      currentPage: 1,
      total: 0,
      value1: '',
      value2: '',
      formLabelWidth: '100px',
      dialog: false,
      // 新增：编辑相关变量
      editDialogVisible: false,
      submitLoading: false,
      editForm: {
        gameName: '',
        gameZh: '',
        gamePsw: '',
        phoneNumber: null
      },
      searchKeyword:'',
      // 新增：添加游戏相关变量
      addDialogVisible: false,
      addLoading: false,
      addForm: {
        gameName: '',
        gameZh: '',
        gamePsw: '',
        phoneNumber: null
      },
      addRules: {
        gameName: [
          { required: true, message: '请输入游戏名称', trigger: 'blur' }
        ],
        gamePsw: [
          { required: true, message: '请输入游戏密码', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { type: 'number', message: '手机号必须为数字', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.search(1);

  },
  methods: {

// 假设在 Vue 组件 methods 中
    searchByName() {

      if (this.searchKeyword === ''|| this.searchKeyword.length<2)
        return

      this.loading = true;
      this.$axios
          .post(`/getMpCookieByName?name=${this.searchKeyword}`, {}) // 或者使用 GET 请求带参数
          .then(response => {
            this.loading = false;
            if (response.data.code === 200) {
              this.tableData = response.data.data.data || [];
              this.total = response.data.data.total;
            } else {
              this.$message.error(response.data.msg || '搜索失败');
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error('网络请求异常');
          });
    },
    openEditDialog(row) {
      this.editForm = {
        gameName: row.gameName,
        gameZh: row.gameZh || '',
        gamePsw: row.gamePsw || '',
        phoneNumber: row.phoneNumber == null ? null : Number(row.phoneNumber)
      };
      this.editDialogVisible = true;
    },
    normalizeText(value) {
      return value == null ? '' : String(value).trim();
    },
    findLoadedDuplicate(field, value, excludedGameName) {
      const normalizedValue = this.normalizeText(value);
      const normalizedExcludedGameName = this.normalizeText(excludedGameName);
      if (!normalizedValue) {
        return null;
      }
      return (this.tableData || []).find(row => {
        if (normalizedExcludedGameName && this.normalizeText(row.gameName) === normalizedExcludedGameName) {
          return false;
        }
        return this.normalizeText(row[field]) === normalizedValue;
      }) || null;
    },
// 新增：提交更新请求
    submitUpdate() {


      // 构造后端需要的 JSON 对象
      const params = {
        gameName: this.normalizeText(this.editForm.gameName),
        game_zh: this.normalizeText(this.editForm.gameZh),
        game_psw: this.normalizeText(this.editForm.gamePsw),
        phoneNumber: this.editForm.phoneNumber
      };
      if (!params.gameName || !params.game_psw) {
        this.$message.error('游戏名称、密码不能为空');
        return;
      }
      if (params.phoneNumber === null || params.phoneNumber === undefined || params.phoneNumber === '') {
        this.$message.error('手机编号不能为空');
        return;
      }
      const duplicateAccount = params.game_zh ? this.findLoadedDuplicate('gameZh', params.game_zh, params.gameName) : null;
      if (duplicateAccount) {
        this.$message.error(`游戏账号已被「${duplicateAccount.gameName}」使用，不能重复`);
        return;
      }

      this.submitLoading = true;

      this.$axios.post('/updateZh', params)
          .then(response => {
            this.submitLoading = false;
            if (response.data.code === 200 || response.data.status === 200) { // 根据实际 Result 结构判断
              this.$message.success('更新成功');
              this.editDialogVisible = false;
              // 刷新当前页数据
              this.search(this.currentPage);
            } else {
              this.$message.error(response.data.msg || '更新失败');
            }
          })
          .catch(error => {
            this.submitLoading = false;
            console.error(error);
            this.$message.error('网络请求异常');
          });
    },
    formatter(row) {
      return row.state === 0 ? '当前浏览器登录' : '未选择';
    }, // 新增：处理页码变化
    handlePageChange(val) {
      this.currentPage = val;
      console.log(val);
      this.search(val);
    },
    search(val) {
      this.loading = true;
      this.$axios
          .post(`/getMpCookie/${this.phoneType}/${this.currentPage}`, {})
          .then(successResponse => {
            this.loading = false;
            if (successResponse.status === 200) {
              this.tableData = successResponse.data.data.data || [];
              this.total = successResponse.data.data.total;
            } else {
              this.$message.error('获取数据失败');
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error('网络请求异常');
          });
    },
    click(row) {
      // 防止右键菜单弹出默认浏览器菜单（可选）
      // event.preventDefault();

      this.$axios.get('/updateState?name=' + row.gameName)
          .then(successResponse => {
            if (successResponse.status === 200) {
              this.$message.success('操作成功');

            } else {
              this.$message.error('操作失败');
            }
          })
          .catch(() => {
            this.$message.error('请求异常');
          });
    },
    cancelForm() {
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
    // 新增：打开添加游戏对话框
    openAddDialog() {
      this.addForm = {
        gameName: '',
        gameZh: '',
        gamePsw: '',
        phoneNumber: null
      };
      this.addDialogVisible = true;
      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.addFormRef) {
          this.$refs.addFormRef.clearValidate();
        }
      });
    },
    // 新增：提交添加游戏请求
    submitAdd() {
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }

        this.addLoading = true;

        // 构造后端需要的 JSON 对象
        const params = {
          gameName: this.normalizeText(this.addForm.gameName),
          gameZh: this.normalizeText(this.addForm.gameZh),
          gamePsw: this.normalizeText(this.addForm.gamePsw),
          phoneNumber: this.addForm.phoneNumber
        };
        if (!params.gameName || !params.gamePsw) {
          this.addLoading = false;
          this.$message.error('游戏名称、密码不能为空');
          return;
        }
        const duplicateName = this.findLoadedDuplicate('gameName', params.gameName);
        if (duplicateName) {
          this.addLoading = false;
          this.$message.error('游戏名称已存在，不能重复添加');
          return;
        }
        const duplicateAccount = params.gameZh ? this.findLoadedDuplicate('gameZh', params.gameZh) : null;
        if (duplicateAccount) {
          this.addLoading = false;
          this.$message.error(`游戏账号已被「${duplicateAccount.gameName}」使用，不能重复添加`);
          return;
        }

        this.$axios.post('/addMpCookie', params)
            .then(response => {
              this.addLoading = false;
              if (response.data.code === 200 || response.data.status === 200) {
                this.$message.success('添加成功');
                this.addDialogVisible = false;
                // 刷新当前页数据
                this.search(this.currentPage);
              } else {
                this.$message.error(response.data.msg || '添加失败');
              }
            })
            .catch(error => {
              this.addLoading = false;
              console.error(error);
              this.$message.error('网络请求异常');
            });
      });
    }
  }
}
</script>

<style scoped>
.game-login-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.box-card {
  max-width: 1500px;
  margin: 0 auto;
  border-radius: 8px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.page-title {
  margin: 0;
  font-size: 18px;
  color: #303133;
  font-weight: 600;
}

.steps-section {
  margin-bottom: 30px;
  padding: 10px 0;
}

.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  background: #fafafa;
  padding: 10px 15px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.filter-group {
  display: flex;
  align-items: center;
}

.label-text {
  font-size: 14px;
  color: #606266;
  margin-right: 10px;
  font-weight: bold;
}

.table-wrapper {
  border-radius: 4px;
  overflow: hidden;
}

/* 优化表格行悬停效果 */
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #ecf5ff !important;
}

::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266;
  font-weight: 600;
}
</style>
